module.exports = __webpack_public_path__ + "assets/img/budapark2-1280.46bbcd46.webp";